import * as angular from "angular";

/* @ngInject */
function BreadcrumbsService() {
  let crumbs = [];

  return {
    breadcrumbs: {
      crumbs: crumbs
    },
    addCrumb: addCrumb,
    showHiddenCrumbs: showHiddenCrumbs,
    reset: reset
  };

  ////////////////

  function addCrumb(item) {
    this.breadcrumbs.crumbs.unshift(item);
    const len = this.breadcrumbs.crumbs.length;
    if (len > 6) {
      for (let i = 0; i < len; i++) {
        if (i >= 2 && i <= len - 2) {
          this.breadcrumbs.crumbs[i].isHidden = true;
        }
      }
    }
  }

  function showHiddenCrumbs() {
    this.breadcrumbs.crumbs.forEach(crumb => {
      if (crumb.hasOwnProperty('isHidden')) crumb.isHidden = false;
    })
  }

  function reset() {
    this.breadcrumbs.crumbs = [];
  }
}


angular
  .module('triangular.components')
  .factory('triBreadcrumbsService', BreadcrumbsService);
